import React, { useEffect, useRef, useState } from 'react';
import Header from '../Component/Layout/Header';
import { MultiSelect } from 'react-multi-select-component';
import { CSVLink } from 'react-csv';
import { dataUser } from '../Component/Helpers/util';
import AntDTable from './Common/AntDTable/AntDTable';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import Sidebar from './Layout/Sidebar';
import { Layout } from 'antd';
import CustomHeader from './Layout/Header';
import axiosInstance from '../utils/axiosInstance';
import AccessLogsExport from './CommonComponent/AccessLogsExport';
import SwSelect from './Common/SwReactSelect/SwReactSelect';
import SwMultiSelect from './Common/SwMultiSelect/SwMultiSelect';
import AntDDatePicker from './Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from "dayjs";
import SwButton from './Common/SwButtons/SwButtons';



const userDataLocal = dataUser();
const UserObj = JSON.parse(userDataLocal);


const AccessContrlReport = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [collapsed, setCollapsed] = useState(true);
  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [deviceType, setDeviceType] = useState('All');
  const [accessLogsData, setAccessLogsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(
    moment().startOf('month').format('YYYY-MM-DD'),
  );
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

  const [totalRecords, setTotalRecords] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [sorterState, setSorterState] = useState(null);
  const [showExportCanvas, setShowExportCanvas] = useState(false);


  const resetRef = useRef(null);
  const exportRef = useRef(null);


  const toggleCollapsed = () => setCollapsed(prev => !prev);

  const handleDeviceTypeChange = e => setDeviceType(e.target.value);

  const columns = [
    {
      title: 'Date',
      dataIndex: 'inOutTimestamp',
      render: val => moment.unix(val).format('DD-MM-YYYY'),
    },
    { title: 'Name', dataIndex: 'full_name' },
    { title: 'Email', dataIndex: 'email' },
    {
      title: 'Location Name',
      dataIndex: ['device', 'location'],
      render: val => getLocationNameById(locations, val),
    },
    {
      title: 'Device Type',
      dataIndex: 'deviceType',
      render: val => val || 'N/A',
    },
    {
      title: 'Time',
      dataIndex: 'inOutTimestamp',
      render: val => moment.unix(val).format('HH:mm:ss'),
    },
    { title: 'Device Name', dataIndex: ['device', 'deviceName'] },
  ];

  const handleSelectionChange = selectedOptions => {
    setSelectedLocations(selectedOptions);
    setSelectedDevices([]);
    setAccessLogsData([]);
  };

  const fetchLocationsBySpoc = () => {
    const authToken = JSON.parse(localStorage.getItem('headData'));
    const headers = {
      Authorization: authToken?.spintlyToken,
      'Content-Type': 'application/json',
    };

    axios
      .get(`${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`, {
        params: { spoc: UserObj?.rec_id, client: UserObj?.company_id },
        headers,
      })
      .then(res => {
        if (res.data.status === 'success') {
          const formattedLocations = res.data.data.map(loc => ({
            label: loc.location_name,
            value: loc.rec_id,
          }));
          setLocations(formattedLocations);

          if (formattedLocations.length > 0) {
            // Select first location by default
            setSelectedLocations([formattedLocations[0]]);
          }
        }
      })
      .catch(err => console.error(err));
  };

  const getDeviceName = async () => {
    try {
      const selectedLocationIds = selectedLocations
        .map(loc => loc.value)
        .join(',');
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }access-control/v3/api/device/get-device-data`,
        {
          params: {
            company_id: UserObj.company_id,
            location: selectedLocationIds,
            deviceFor: 'All',
          },
        },
      );

      if (res.data.statusValue === 200) {
        const deviceIds = res.data.data.map(device => device._id);
        setSelectedDevices(deviceIds);
      } else {
        setSelectedDevices([]);
      }
    } catch (err) {
      setSelectedDevices([]);
    }
  };

  const getAccessLogsData = async (page = 1, size = 25, sorter = null) => {
    if (isFetching) return;
    setIsFetching(true);
    setLoading(true);

    try {
      const selectedLocationIds = selectedLocations
        .map(loc => loc.value)
        .join(',');

      const requestBody = {
        location: selectedLocationIds,
        startTime: startDate,
        endTime: endDate,
        page,
        limit: size,
        deviceType,
        company_id: UserObj?.company_id,
      };

      if (selectedDevices.length > 0) {
        requestBody.deviceId = selectedDevices.join(',');
      }

      // Add sorting params if sorter exists
      if (sorter?.field && sorter?.order) {
        requestBody.sortField = sorter.field;
        requestBody.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc';
      }

      const res = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }access-control/v3/api/device/inout-logs-csp`,
        requestBody,
      );

      if (res.data.statusValue === 200) {
        setAccessLogsData(res.data.data);

        setTotalRecords(res.data.pagination.totalRecords);
      }
    } catch (error) {
      console.error('Error fetching access logs:', error);
      toast.error('Failed to fetch access logs. Please try again.');
    }
    finally {
      setLoading(false);
      setIsFetching(false); // 👈 You forgot this
    }
  };

  const handleSubmit = () => {
    if (
      selectedLocations.length &&
      (selectedDevices.length > 0 || deviceType !== '')
    ) {
      setPage(1);
      getAccessLogsData(1);
    } else {
      toast.error(
        'Please select at least one location and a valid device or device type.',
      );
    }
  };

  const handleExport = () => {
    const formattedData = accessLogsData?.map(item => ({
      date: moment.unix(item?.inOutTimestamp).format('DD-MM-YYYY'),
      name: item.full_name,
      email: item.email,
      location: getLocationNameById(locations, item?.device?.location),
      deviceType: item?.deviceType,
      time: moment.unix(item?.inOutTimestamp).format('HH:mm:ss'),
      deviceName: item?.device?.deviceName,
    }));

    const headers = [
      { label: 'Date', key: 'date' },
      { label: 'Name', key: 'name' },
      { label: 'Email', key: 'email' },
      { label: 'Location', key: 'location' },
      { label: 'Device Type', key: 'deviceType' },
      { label: 'Time', key: 'time' },
      { label: 'Device Name', key: 'deviceName' },
    ];

    return { data: formattedData, headers, filename: 'FR Logs.csv' };
  };

  function getLocationNameById(locationData, locationId) {
    for (let i = 0; i < locationData.length; i++) {
      if (locationData[i].value == locationId) {
        return locationData[i].label;
      }
    }
    return '';
  }

  // 🌟 useEffect sequence
  useEffect(() => {
    fetchLocationsBySpoc();
  }, []);

  useEffect(() => {
    if (selectedLocations.length > 0) {
      getDeviceName();
    } else {
      setSelectedDevices([]);
    }
  }, [selectedLocations]);

  useEffect(() => {
    if (selectedDevices.length > 0) {
      getAccessLogsData(1);
    }
  }, [selectedDevices]);
  const deviceTypeOptions = [
    { value: 'All', label: 'All' },
    { value: 'Face', label: 'Face' },
    { value: 'QR', label: 'QR' },
  ];

  return (
    <>
      <AccessLogsExport show={showExportCanvas} onClose={() => setShowExportCanvas(false)} />
      <Layout>
        <Sidebar collapsed={collapsed} />
        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
        <Layout
          className={
            collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'
          }
        >
          <div className="PageContent">
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row mb-4">
                  <div className="col-md-6">
                    <div className="SwHeading">
                      <h2>Access Logs</h2>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="PageHead_Optons_Row">
                      <ul className='PageHead_Optons_RightAligned'>
                        <li>
                          <SwButton
                            variant="dark"
                            size='sm'
                            icon={<i className="bi bi-box-arrow-right"></i>}
                            iconPosition="start"
                            onClick={() => setShowExportCanvas(true)}
                          >
                            Export Access Logs
                          </SwButton>

                        </li>
                      </ul>
                    </div>
                  </div>
                </div>


                <div className='row'>
                  <div className='col-md-10'>
                    <div className="row">
                      <div className="col-md-3">
                        <div className="SwFormGroup">
                          <label className="SwFormLabel">Location</label>

                          <SwMultiSelect
                            options={locations}
                            value={selectedLocations}
                            onChange={handleSelectionChange}
                            labelledBy="Select"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="SwFormGroup">
                              <label className='SwFormLabel'>Start Date</label>
                              <AntDDatePicker
                                value={startDate ? dayjs(startDate, "YYYY-MM-DD") : null}
                                format="DD/MM/YYYY"
                                disabledDate={(current) => {
                                  if (!current) return false;

                                  // Match Access Log Export: from start of month 3 months ago to today
                                  const minDate = dayjs().subtract(3, "month").startOf("month");
                                  const maxDate = dayjs().endOf("day");

                                  return current.isBefore(minDate) || current.isAfter(maxDate);
                                }}
                                onChange={(date) => {
                                  if (!date) return;

                                  const selectedStartDate = date.format("YYYY-MM-DD");

                                  // If End Date is now before Start Date or in a different month, reset it
                                  if (
                                    endDate &&
                                    (moment(selectedStartDate).isAfter(endDate, "day") ||
                                      date.month() !== dayjs(endDate, "YYYY-MM-DD").month() ||
                                      date.year() !== dayjs(endDate, "YYYY-MM-DD").year())
                                  ) {
                                    setEndDate(selectedStartDate);
                                  }
                                  setStartDate(selectedStartDate);
                                }}
                                allowClear={false}
                              />


                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="SwFormGroup">
                              <label className='SwFormLabel'>End Date</label>
                              <AntDDatePicker
                                value={endDate ? dayjs(endDate, "YYYY-MM-DD") : null}
                                format="DD/MM/YYYY"
                                disabledDate={(current) => {
                                  if (!current) return false;

                                  // Match Access Log Export: within 3-month window AND same calendar month as Start Date
                                  const windowMin = dayjs().subtract(3, "month").startOf("month");
                                  const windowMax = dayjs().endOf("day");
                                  if (current.isBefore(windowMin) || current.isAfter(windowMax)) return true;

                                  if (startDate) {
                                    const start = dayjs(startDate, "YYYY-MM-DD");
                                    if (current.isBefore(start, "day")) return true;
                                    if (current.month() !== start.month() || current.year() !== start.year()) return true;
                                  }
                                  return false;
                                }}
                                onChange={(date) => {
                                  if (!date) return;

                                  const selectedEndDate = date.format("YYYY-MM-DD");

                                  if (
                                    !startDate ||
                                    moment(selectedEndDate).isSameOrAfter(startDate, "day")
                                  ) {
                                    setEndDate(selectedEndDate);
                                  } else {
                                    toast.error("End date must be on or after start date");
                                  }
                                }}
                                allowClear={false}
                              />


                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="SwFormGroup">
                          <label className="SwFormLabel">Device Type</label>
                          <SwSelect
                            options={deviceTypeOptions}
                            isClearable={false}
                            placeholder="Select Device type"
                            value={deviceTypeOptions.find(
                              opt => opt.value === deviceType,
                            )}
                            onChange={selectedOption => {
                              handleDeviceTypeChange({
                                target: {
                                  value: selectedOption
                                    ? selectedOption.value
                                    : 'All',
                                },
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div >
                  <div className='col-md-2'>
                    <div className="SwFormGroup">
                      <label className="SwFormLabel invisible">No Label</label>
                      <SwButton
                        size="sm"
                        variant="dark-outline"
                        icon={<i className="bi bi-arrow-right" />}
                        iconPosition="end"
                        onClick={handleSubmit}
                        loading={loading}
                      >
                        Apply Filters
                      </SwButton>

                    </div>
                  </div>
                </div >



                <div className="row mt-4 position-relative">
                  <div className="col-12">
                    <div className="">
                      <AntDTable
                        columns={columns}
                        dataSource={accessLogsData}
                        rowKey="_id"
                        loading={loading}
                        clientSideSorting={false}
                        pagination
                        currentPage={page}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        showTotal
                        onPageChange={(p, size) => {
                          setPage(p);
                          setPageSize(size);
                          getAccessLogsData(p, size, sorterState); // ✅ use new values
                        }}
                        onChange={(pagination, filters, sorter) => {
                          const { current, pageSize } = pagination;

                          setPage(current);
                          setPageSize(pageSize);
                          setSorterState(sorter);

                          getAccessLogsData(current, pageSize, sorter); // ✅ use new values
                        }}
                        onRowClick={row => console.log('Row clicked:', row)}
                      />
                    </div>
                  </div>
                </div >
              </div >
            </div >
          </div >
        </Layout >
      </Layout >
    </>
  );
};

export default AccessContrlReport;
